import useMessageDetails from 'Hooks/useMessageDetails'
import { evalCondition } from 'mailup-react-helpers'
import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import {
  Loading,
  MESSAGE_BOX_VARIANT_WARNING,
  Tooltip,
  TooltipUtils
} from 'mailup-web-components'

import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import BoxNoSpamCheckOption from './components/BoxNoSpamCheckOption'
import BoxSpamAssassin from './components/BoxSpamAssassin'
import Footer from './components/Footer'
import Header from './components/Header'
import ModalBeingSent from './components/ModalBeingSent'

import {
  pageErrorState,
  pageLoadingState
} from 'Pages/MessageCheckupSpamCheck/recoil/state/page'

const MessageCheckupSpamCheck = () => {
  const { id } = useParams()
  const error = useRecoilValue(pageErrorState(id))
  const loading = useRecoilValue(pageLoadingState(id))

  useMessageDetails(+id)

  const canCheck = evalCondition('co:SPAMCHECK OR c:IsTrial')

  useEffect(() => {
    TooltipUtils.rebuild()
  })

  const reloadPage = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <>
      <Header />
      <Loading open={loading} />
      <Tooltip />
      <ModalBeingSent />
      <PageContainer>
        <ErrorFeedback
          error={error}
          severity={MESSAGE_BOX_VARIANT_WARNING}
          onClickReload={reloadPage}
        />
        {!error && !loading && (
          <>
            {canCheck ? (
              <>
                <BoxSpamAssassin idMessage={id} />
                {/* 
                nascosta per la TRAIL-5012
                <BoxDeliverability idMessage={id} /> */}
              </>
            ) : (
              <BoxNoSpamCheckOption />
            )}

            <Footer idMessage={+id} />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default MessageCheckupSpamCheck
